/* eslint-disable import/no-unresolved */
import { useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  IconButton,
} from '@mui/material';
import { selectOrder } from '@/store/selectors';
import InvoiceDetails from './InvoiceDetails';
// import { InvoiceStatusType } from '@/types/utils';

const boxStyle = {
  position: 'absolute',
  height: 'max-content',
  width: '793px',
  backgroundColor: '#FAFAFA',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 8,
};

interface InvoiceInfoProps {
  status: any;
  show: boolean;
  handleToggleModal: (type: 'delete' | 'refund' | 'info') => void;
}
const InvoiceInfo: React.FC<InvoiceInfoProps> = ({
  status,
  show,
  handleToggleModal,
}) => {
  const { current_invoice: invoice, customer } = useSelector(selectOrder);

  return (
    <div>
      <Modal
        open={show}
        onClose={() => handleToggleModal('info')}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={show} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box sx={{ textAlign: 'left', marginBottom: 6 }}>
              <IconButton
                onClick={() => handleToggleModal('info')}
                sx={{
                  width: '92px',
                  height: '40px',
                  borderRadius: '90px',
                  p: '12px 16px',
                  position: 'absolute',
                  left: 0,
                  top: '10px',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    marginLeft: 1,
                    fontFamily: 'Montserrat',
                    color: (theme) => theme.palette.primary.main,
                  }}
                >
                  Close
                </Typography>
              </IconButton>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 2,
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  lineHeight: '15px',
                  fontWeight: 600,
                  textAlign: 'center',
                  fontSize: '20px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  color: (theme) => theme.palette.primary.main,
                  '& span': {
                    mr: 1,
                  },
                }}
              >
                <span>Invoice No:</span>
                {invoice}
              </Typography>
              <Typography
                variant="h4"
                sx={{
                  lineHeight: '15px',
                  fontWeight: 600,
                  textAlign: 'center',
                  fontSize: '12px',
                  fontFamily: 'Montserrat',
                  textTransform: 'capitalize',
                  color: '#000000',
                }}
              >
                {customer}
              </Typography>
            </Box>

            <InvoiceDetails status={status} />
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default InvoiceInfo;
